"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
const react_native_1 = require("react-native");
const Login_style_1 = require("./Login.style");
const react_1 = __importStar(require("react"));
const atome_1 = require("../../atome");
const User_service_1 = __importDefault(require("../../../services/User.service"));
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const organisms_1 = require("../../organisms");
const Breakpoints_1 = require("../../../helper/Breakpoints");
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
// @ts-ignore
function Login({ navigation, route, setUserInfo }) {
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [email, setEmail] = (0, react_1.useState)('');
    const [password, setPassword] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)('');
    // Activate User's Account
    (0, react_1.useEffect)(() => {
        const hasEmailAndTokenInParams = route.params?.token && route.params?.email;
        if (hasEmailAndTokenInParams) {
            User_service_1.default.activateAccount(route.params.token, route.params?.email).then(res => {
                if (res.error) {
                    console.error(res);
                }
            });
        }
    }, []);
    (0, react_1.useEffect)(() => {
        if (auth.isAuthenticated) {
            navigation.navigate('Dashboard');
        }
        return () => { };
    }, [auth.isAuthenticated]);
    const login = async () => {
        setError('');
        const loginData = {
            email: email,
            password: password,
        };
        const response = await User_service_1.default.login(loginData);
        if (!response.error) {
            await async_storage_1.default.setItem('JWT', response.data.token);
            await async_storage_1.default.setItem('User', response.data.name);
            await async_storage_1.default.setItem('TermsAgree', String(response.data.isTermsAgree));
            await async_storage_1.default.setItem('PrivacyPolicyAgree', String(response.data.isPrivacyPolicyAgree));
            await async_storage_1.default.setItem('FirstTime', 'false');
            setEmail('');
            setPassword('');
            const authData = {
                isAuthenticated: true,
                isTermsAgree: response.data.isTermsAgree,
                name: response.data.name,
                isPrivacyPolicyAgree: response.data.isPrivacyPolicyAgree,
                isNewsletterAgree: response.data.isNewsletterAgree,
            };
            dispatch((0, reducers_1.setAuth)(authData));
            User_service_1.default.information().then(r => {
                if (r.error) {
                    console.log(r.message);
                }
                setUserInfo(r.data);
                dispatch((0, reducers_1.setUserInformation)(r.data));
            });
            setTimeout(() => {
                navigation.navigate('Dashboard');
            }, 500);
        }
        if (response.error) {
            if (response.message.response?.data?.error) {
                setError(response.message.response.data.error);
            }
            else {
                setError('error');
            }
            console.log(response.message);
        }
    };
    const onRegistrationButton = () => {
        navigation.navigate('RegisterProcedure');
        if (react_native_1.Platform.OS === 'web') {
            window.dataLayer.push({
                event: 'event',
                eventProps: {
                    category: 'registrationButton',
                    action: 'onClick',
                    label: 'Buttons Click',
                },
            });
        }
    };
    if (!Breakpoints_1.isDesktop && react_native_1.Platform.OS === 'web') {
        const windowWidth = react_native_1.Dimensions.get('window').width;
        const promoImageRatio = 0.889;
        //detect os
        let os = null;
        var userAgent = navigator.userAgent || navigator.vendor;
        if (/android/i.test(userAgent)) {
            os = 'Android';
        }
        else if (/iPad|iPhone|iPod/.test(userAgent)) {
            os = 'iOS';
        }
        return (react_1.default.createElement(react_native_1.SafeAreaView, null,
            react_1.default.createElement(react_native_1.ScrollView, { style: Login_style_1.styles.scrollview },
                react_1.default.createElement(organisms_1.BaseHeader, null),
                react_1.default.createElement(react_native_1.View, { style: [Login_style_1.styles.container, { alignItems: 'center' }] },
                    react_1.default.createElement(atome_1.Label, { style: [
                            {
                                marginTop: 10,
                                marginBottom: 10,
                                fontSize: 26,
                                textAlign: 'center',
                            },
                        ] }, route.params?.token
                        ? 'Verifizierung erfolgreich!'
                        : 'Gleich geht es los'),
                    route.params?.token && (react_1.default.createElement(atome_1.Label, { style: [
                            {
                                marginTop: 20,
                                marginBottom: 20,
                                fontSize: 16,
                                textAlign: 'center',
                                lineHeight: 27,
                            },
                        ] }, "Sie k\u00F6nnen sich nun in der nowomed App einloggen.")),
                    react_1.default.createElement(atome_1.Label, { style: [
                            {
                                marginTop: 20,
                                marginBottom: 10,
                                fontSize: 16,
                                textAlign: 'center',
                                lineHeight: 27,
                            },
                        ] },
                        "1. App herunterladen",
                        '\n',
                        "2. Einloggen",
                        '\n',
                        "3. Therapie starten"),
                    react_1.default.createElement(atome_1.Label, { style: [
                            {
                                marginTop: 20,
                                marginBottom: 10,
                                fontSize: 16,
                                textAlign: 'center',
                                lineHeight: 27,
                            },
                        ] }, "Die gesamte Therapie ganz komfortabel in einer App."),
                    (os === 'iOS' || os === null) && (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => react_native_1.Linking.openURL('https://apps.apple.com/de/app/nowomed/id1616501886') },
                        react_1.default.createElement(react_native_1.Image, { source: require('../../../assets/images/btn_appstore.png'), style: { width: 200, height: 100, resizeMode: 'contain' } }))),
                    (os === 'Android' || os === null) && (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => react_native_1.Linking.openURL('https://play.google.com/store/apps/details?id=com.nowomed.patients') },
                        react_1.default.createElement(react_native_1.Image, { source: require('../../../assets/images/btn_google_play.png'), style: { width: 200, height: 100, resizeMode: 'contain' } }))),
                    react_1.default.createElement(react_native_1.Image, { source: require('../../../assets/images/promotion_app.jpg'), style: {
                            width: windowWidth,
                            height: windowWidth / promoImageRatio,
                            marginTop: 40,
                            marginBottom: 30,
                        } })))));
    }
    if (!Breakpoints_1.isDesktop) {
        return (react_1.default.createElement(react_native_1.SafeAreaView, { style: { backgroundColor: 'white' } },
            react_1.default.createElement(react_native_1.ScrollView, { style: [Login_style_1.styles.scrollview] },
                react_native_1.Platform.OS === 'web' && react_1.default.createElement(organisms_1.BaseHeader, null),
                react_1.default.createElement(react_native_1.View, { style: [
                        Login_style_1.styles.container,
                        Login_style_1.styles.marginTop100,
                        { alignItems: 'center' },
                    ] },
                    react_1.default.createElement(atome_1.Label, { style: [Login_style_1.styles.firstLabel] }, "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an."),
                    react_1.default.createElement(react_native_1.View, { style: Login_style_1.styles.inputContainer },
                        react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(atome_1.Label, null, "E-Mail-Adresse")),
                        react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(atome_1.InputField, { onChange: setEmail, value: email, style: [Login_style_1.styles.input], isEmail: true, onKeyPress: event => event.nativeEvent.key === 'Enter' ? login() : null })),
                        error === 'email' && (react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.error] }, "Die E-Mail-Adresse ist falsch.")),
                        error === 'error' && (react_1.default.createElement(react_native_1.View, { style: Login_style_1.styles.row },
                            react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.errorServer] }, "Es ist ein Fehler aufgetreten, versuchen Sie es bitte erneut.")))),
                    react_1.default.createElement(react_native_1.View, { style: [Login_style_1.styles.inputContainer] },
                        react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(atome_1.Label, null, "Passwort")),
                        react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(atome_1.InputField, { onChange: setPassword, secure: true, value: password, style: [Login_style_1.styles.input], onKeyPress: event => event.nativeEvent.key === 'Enter' ? login() : null })),
                        error === 'password' && (react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.error] }, "Das Passwort ist nicht korrekt."))),
                    react_1.default.createElement(react_native_1.View, { style: Login_style_1.styles.errorDeleteContainer }, error === 'delete' && (react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.errorDelete] }, "Ihr Account befindet sich auf Ihren Wunsch in einem L\u00F6schungsvorgang. Sie k\u00F6nnen sich nicht mehr anmelden."))),
                    react_1.default.createElement(react_native_1.View, { style: Login_style_1.styles.errorPharmacyUserContainer }, error === 'pharmacyUser' && (react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.errorDelete] }, "Dieses Angebot richtet sich an die Patienten von nowomed. Fahren Sie \u00FCber \u201CJetzt registrieren\u201D fort, um eine kostenlose Therapieanfrage zu stellen."))),
                    react_1.default.createElement(react_native_1.View, { style: [Login_style_1.styles.buttonContainer] },
                        error === 'active' && (react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.errorUnverified] }, "Ihr Account ist nicht verifiziert. Bitte verifizieren Sie Ihren Account \u00FCber den Link in der Ihnen gesendeten E-Mail.")),
                        react_1.default.createElement(react_native_1.Pressable, { style: [Login_style_1.styles.button, { marginTop: 30 }], onPress: login },
                            react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.buttonText] }, "Anmelden")),
                        react_1.default.createElement(react_native_1.Pressable, { style: Login_style_1.styles.marginTop20, onPress: () => navigation.navigate('ForgotPassword') },
                            react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.backButtonText] }, "Passwort vergessen?")),
                        react_1.default.createElement(atome_1.Label, { style: [
                                Login_style_1.styles.marginTop50,
                                Login_style_1.styles.marginBottom20,
                                Login_style_1.styles.alignCenter,
                            ] }, "Sie haben noch kein Konto?"),
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => onRegistrationButton() },
                            react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.backButtonText] }, "Jetzt kostenfrei registrieren")))))));
    }
    const onRegistratiomButon = () => {
        navigation.navigate('RegisterStepOne');
        window.dataLayer.push({
            event: 'event',
            eventProps: {
                category: 'registrationButton',
                action: 'onClick',
                label: 'Buttons Click',
            },
        });
        console.log(window.dataLayer);
    };
    return (react_1.default.createElement(react_native_1.SafeAreaView, null,
        react_1.default.createElement(organisms_1.BaseHeader, { navigation: navigation }),
        react_1.default.createElement(react_native_1.View, { style: Login_style_1.styles.container },
            react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.heading3] }, route.params?.token ? 'Verifizierung erfolgreich!' : 'Login'),
            react_1.default.createElement(atome_1.Label, { style: [{ marginBottom: 20 }] }, "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an."),
            react_1.default.createElement(react_native_1.View, { style: Login_style_1.styles.inputContainer },
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(atome_1.Label, null, "E-Mail-Adresse")),
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(atome_1.InputField, { onChange: setEmail, value: email, style: [Login_style_1.styles.input], onKeyPress: event => event.nativeEvent.key === 'Enter' ? login() : null })),
                error === 'email' && (react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.error] }, "Die E-Mail-Adresse ist falsch.")),
                error === 'error' && (react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.error] }, "Es ist ein Fehler aufgetreten, versuchen Sie es bitte erneut."))),
            react_1.default.createElement(react_native_1.View, { style: [Login_style_1.styles.inputContainer, Login_style_1.styles.marginBottomXL] },
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(atome_1.Label, null, "Passwort")),
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(atome_1.InputField, { onChange: setPassword, secure: true, value: password, style: [Login_style_1.styles.input], onKeyPress: event => event.nativeEvent.key === 'Enter' ? login() : null })),
                error === 'password' && (react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.error] }, "Das Passwort ist nicht korrekt."))),
            react_1.default.createElement(react_native_1.View, null, error === 'delete' && (react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.errorDelete] }, "Ihr Account befindet sich auf Ihren Wunsch in einem L\u00F6schungsvorgang. Sie k\u00F6nnen sich nicht mehr anmelden."))),
            react_1.default.createElement(react_native_1.View, null, error === 'pharmacyUser' && (react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.errorDelete] }, "Dieses Angebot richtet sich an die Patienten von nowomed. Fahren Sie \u00FCber \u201CJetzt registrieren\u201D fort, um eine kostenlose Therapieanfrage zu stellen."))),
            react_1.default.createElement(react_native_1.View, { style: [Login_style_1.styles.buttonContainer] },
                error === 'active' && (react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.errorUnverified] }, "Ihr Account ist nicht verifiziert. Bitte verifizieren Sie Ihren Account \u00FCber den Link in der Ihnen gesendeten E-Mail.")),
                react_1.default.createElement(react_native_1.Pressable, { style: Login_style_1.styles.button, onPress: login },
                    react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.buttonText] }, "Anmelden")),
                react_1.default.createElement(react_native_1.Pressable, { style: Login_style_1.styles.marginTop20, onPress: () => navigation.navigate('ForgotPassword') },
                    react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.backButtonText] }, "Passwort vergessen?")),
                !route.params?.token && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(atome_1.Label, { style: [
                            Login_style_1.styles.marginTop50,
                            Login_style_1.styles.marginBottom20,
                            Login_style_1.styles.alignCenter,
                        ] }, "Sie haben noch kein Konto?"),
                    react_1.default.createElement(react_native_1.Pressable, { onPress: () => onRegistrationButton() },
                        react_1.default.createElement(atome_1.Text, { style: [Login_style_1.styles.backButtonText] }, "Jetzt kostenfrei registrieren"))))))));
}
exports.Login = Login;
